export default __webpack_public_path__ + "static/media/08.eeec0331.jpg";